'use client';

import { useState } from 'react';
import FallBackImage from '../../components/FallBackImage';
import { twMerge } from 'tailwind-merge';
import Play from '../../components/svg/FeedPlay';import Image from 'next/image';
;


interface Props {
  title: string;
  src: string;
  placeholder: string;
  thumbnail: string;
  alt: string;
  device?: string;
}

export default function VideoPlayer({title, src, placeholder, alt, thumbnail, device}: Props) {
  const [init, setInit] = useState(false);

  if (init) {
    return (
      <iframe
      width="100%"
      height="100%"
      src={src}
      title={title}
      allow="accelerometer; clipboard-write; encrypted-media; gyroscope;"
      allowFullScreen
      />
    )
  }
  else {
    return (
      <div 
        className={twMerge('relative w-full h-full before:bg-black before:rounded-full before:h-[15%] before:w-auto before:aspect-square before:absolute before:top-[50%] before:left-[50%] before:translate-x-[-50%] before:translate-y-[-50%] before:z-[3] before:opacity-[0.7]',)}
        onClick={() => setInit(true)}
      >
        <Play className='w-auto h-[10%] aspect-square z-[4] absolute top-[50%] left-[50%] translate-x-[-50%] translate-y-[-50%]' />
      <FallBackImage
        eager
        fill
        sizes='100vw'
        src={placeholder}
        thumbnail={thumbnail}
        alt={alt}

      />
      </div>
    )
  }


}